import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
//
// Library Model/Services
//
import { Response } from '../../../../lib/angular/model/common/response';
import { SpecialOffer } from '../../../../lib/angular/model/dealer/special-offer/special-offer';
import { RtiHttpService } from '../../../../lib/angular/service/rti-HttpService';

//
// App Service(s)
//
import { RtiJsonService } from '../../../../lib/angular/service/common/rti-JsonService';
import { ddHttpService } from '../dd-HttpService';
import * as Library from '../../../../lib/core/library';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class ddLocalSpecialService extends ddHttpService {
  //
  // Rest API Endpoint
  //
  static readonly GET_API: string = 'offers-service/OFFERS/alloffers';

  /**
   * getByCode()
   */
  public get(params: object): Observable<Response<SpecialOffer>> {
    //
    // return super._get<SpecialOffer>(ddLocalSpecialService.GET_API, this._map, params);
    //
    // ::SDL Temporary using json file
    //
    return this._jsonService.get('assets/json/local-specials.json').pipe(
      map(item => {
        //
        // Parsing data into SpecialOffer model
        //
        const resp = new Response<SpecialOffer>([new SpecialOffer(item)]);
        return resp;
      })
    );
  }

  /**
   * put()
   */
  public put(model: SpecialOffer): Observable<Response<SpecialOffer>> {
    return super._put<SpecialOffer>(ddLocalSpecialService.GET_API, model, null, this._map);
  }

  /**
   * post()
   */
  public post(model: any): Observable<Response<SpecialOffer>> {
    return super._post<SpecialOffer>(ddLocalSpecialService.GET_API, model, this._map);
  }

  /**
   * patch()
   */
  public patch(model: any): Observable<Response<SpecialOffer>> {
    return null;
  }

  /**
   * delete()
   */
  public delete(): Observable<Response<SpecialOffer>> {
    return super._delete<SpecialOffer>(ddLocalSpecialService.GET_API, {}, this._map);
  }

  /**
   * _map()
   */
  private _map(item: any): SpecialOffer {
    return new SpecialOffer(item);
  }

  /**
   * Function: constructor()
   */
  constructor(http: RtiHttpService,
              environment: EnvironmentConfiguration,
              private _jsonService: RtiJsonService) {
    super(http, environment);
  }
}
